import React from "react";
import "./Footer.css";
import LogoImage from "images/logo white.png";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom"
const Footerr = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" style={{ marginLeft: "-33px", marginRight: "-33px", marginBottom: "-50px" }}>
      <div className="footer-content">

        {/* Left Section */}
        <div className="footer-brand">
          <img src={LogoImage} alt="Rehab Bio Logo" className="footer-logo" />
          <p className="footer-description">
            {t("footer.brand_description")}
          </p>

          <h4 className="footer-subtitle">{t("footer.follow_us")}</h4>
          <div className="footer-socials">
            <i className="fab fa-facebook-f" />
            <i className="fab fa-instagram" />
            <i className="fab fa-tiktok" />
            <i className="fab fa-whatsapp" />
            <i className="fab fa-youtube" />
          </div>

          {/* <h4 className="footer-subtitle">{t("footer.newsletter")}</h4> */}
          {/* <p className="footer-note">{t("footer.newsletter_note")}</p> */}
        </div>


<div className="footer-columns">
  <div className="footer-col">
    <h4>{t("footer.brand")}</h4>
    <ul>
      <li><Link to="/à-props">{t("footer.about")}</Link></li>
      {/* <li><Link to="/blog">{t("footer.blog")}</Link></li> */}
    </ul>
  </div>

  <div className="footer-col">
    <h4>{t("footer.ranges")}</h4>
    <ul>
      <li><Link to="/Cadeaux">{t("categories_menu.Cadeaux")}</Link></li>
      <li><Link to="/Librairie">{t("categories_menu.Librairie_Papeterie")}</Link></li>
      <li><Link to="/Electromenager">{t("categories_menu.Electromenager")}</Link></li>
      <li><Link to="/AccessoiresTelephone">{t("categories_menu.Accessoires_Telephone")}</Link></li>
      <li><Link to="/Montres">{t("categories_menu.Montres")}</Link></li>
      <li><Link to="/Cosmetiques">{t("categories_menu.Cosmetiques_Complements")}</Link></li>
      <li><Link to="/Parfums">{t("categories_menu.Parfums")}</Link></li>
      <li><Link to="/Chaussures">{t("categories_menu.Chaussures")}</Link></li>
      <li><Link to="/Textile">{t("categories_menu.Textile_Habillement")}</Link></li>
      <li><Link to="/Bijoux">{t("categories_menu.Bijoux")}</Link></li>
      <li><Link to="/Construction">{t("categories_menu.Materiaux_Construction")}</Link></li>
      <li><Link to="/ProduitsNaturels">{t("categories_menu.Produits_Naturels")}</Link></li>
    </ul>
  </div>

  <div className="footer-col">
    <h4>{t("footer.customer_service")}</h4>
    <ul>
      <li><Link to="/contact">{t("footer.faq")}</Link></li>
      <li><Link to="/contact">{t("footer.contact_us")}</Link></li>
      <li><Link to="/contact">{t("footer.refund_policy")}</Link></li>
      <li><Link to="/contact">{t("footer.privacy_policy")}</Link></li>
      <li><Link to="/contact">{t("footer.terms")}</Link></li>
    </ul>
  </div>

  {/* <div className="footer-col">
    <h4>{t("footer.earn_money")}</h4>
    <Link to="/signup">
      <button className="footer-btn">{t("footer.become_affiliate")}</button>
    </Link>
    <Link to="/signup">
      <button className="footer-btn">{t("footer.become_affiliate_ar")}</button>
    </Link>
  </div> */}
</div>

      </div>

      <div className="footer-bottom">
        <p>© AgencyWmg</p>
        <p>
          &copy; {t('footer.created_by')} <a href="https://agencywmg.com/" style={{ color: '#FFFFF' }}>
            agencywmg</a>. {t('footer.all_rights_reserved')}
        </p>
      </div>
    </footer>
  );
};

export default Footerr;
